// src/pages/crm/CRM.js
import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import { Link } from "react-router-dom";
import "../../styles/custom.css";
import API_BASE_URL from "../../config";

const CRM = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    document.title = "CRM | Webyappy";

    fetch(`${API_BASE_URL}/auth/check_session`, {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "active") {
          setUser(data.user);
        }
      });
  }, []);

  const hasAccess = (key) =>
    user?.role === "Superadmin" || user?.assigned_microapps?.includes(key);

  return (
    <>
      <Header />
      <div style={{ paddingTop: "70px", paddingBottom: "70px" }}>
        <div className="container-fluid px-3 py-3">
          {/* Breadcrumb */}
          <div className="d-flex align-items-center justify-content-between mb-4">
            <ul className="breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bold mb-0 p-0">
              <li className="breadcrumb-item">
                <Link to="/home" className="text-muted">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item">
                <span className="text-muted">CRM</span>
              </li>
            </ul>
          </div>

          {/* CRM Cards */}
          <div className="row">
            {/* CRM Microapp Card */}
            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 mb-5">
              <div className="card department-microapp-card shadow-sm h-100">
                <div className="card-body position-relative">
                  <h6 className="text-dark font-weight-bold mb-3">Leads</h6>
                  <hr />
                  <ul className="list-unstyled mb-0">
                    {hasAccess("crm_add_lead") && (
                      <li className="mb-2">
                        <Link to="/pages/crm/addlead" className="microapp-link">
                          Add Lead
                        </Link>
                      </li>
                    )}
                    {hasAccess("crm_view_lead") && (
                      <li className="mb-2">
                        <Link to="/pages/crm/viewleads" className="microapp-link">
                          View Leads
                        </Link>
                      </li>
                    )}
                    {hasAccess("crm_edit_lead") && (
                      <li>
                        <Link to="/pages/crm/editleads" className="microapp-link">
                          Edit Leads
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CRM;
